import { apiClient } from '../../api/fetchClient';
import type { FeatureFlagsMap } from '../models/feature-flags.model';

class FeatureFlagService {
  getFeatureFlags(): Promise<FeatureFlagsMap> {
    return apiClient.get<FeatureFlagsMap>('/apps/single/v3/feature-flags');
  }
}

export const featureFlagService = new FeatureFlagService();
